module.exports = __webpack_public_path__ + "img/005.5a97e5e6.png";